<template>
  <v-card class="text-xs-center">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-progress-circular v-if="loading" indeterminate :height="2" class="primary--text"></v-progress-circular>
      <slot></slot>
    </v-card-text>
    <v-card-row actions v-if="$slots.actions">
      <slot name="actions"></slot>
    </v-card-row>
  </v-card>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
  .card__title {
    text-align: center;
    justify-content: center;
  }

  .card__text {
    font-size: 3em;
    padding-top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .progress-circular {
    position: absolute;
    top: .25em;
    right: .25em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Stat.vue